// @ts-check
/* eslint-disable */
import { createStore } from 'vuex';
import moduleA from './modules/user';
import modulePage from './modules/page';
import { getLeaseList } from "@/request/view/equipment";
import { setDepartmentUnuse } from '@/components/chooseStaff/serve';

export default createStore({
  state: {
    isMonile: false,
    mobileSearchParams: {
      customer: '',
      equipment: '',
      isExpires: null,
      lt3Days: null,
      isActivation: null,
    },
    mobilePage: {
      pageNum: 1,
      lineNum: 10,
      total: 0,
    },
    mobileTableData: [],
    notice: [],
    unReadNum: 0,
    noticeStaffData: [],
    project: null,
  },
  mutations: {
    SET_PROJECT_NAME(state, val) {
      state.project = val;
    },
    SET_NOTICE_STAFF_DATA(state, val) {
      state.noticeStaffData = setDepartmentUnuse(val);
    },
    SET_UNREADNUM(state, val) {
      state.unReadNum = val < 0 ? 0 : val;
    },
    SET_MOBILE(state, val) {
      state.isMonile = val;
    },
    // 手机端搜索参数赋值
    SET_MOBILE_SEARCH(state, data) {
      state.mobileSearchParams.customer = data.customer;
      state.mobileSearchParams.equipment = data.equipment;
      state.mobileSearchParams.isExpires = data.isExpires;
      state.mobileSearchParams.lt3Days = data.lt3Days;
      state.mobileSearchParams.isActivation = data.isActivation;
    },
    // 手机端分页参数赋值
    SET_MOBILE_PAGE(state, page) {
      if (page.pageNum) state.mobilePage.pageNum = page.pageNum;
      if (page.lineNum) state.mobilePage.lineNum = page.lineNum;
      if (page.total || page.total === 0) state.mobilePage.total = page.total;
    },
    // 手机端租赁table数据
    SET_LEASE_TABLE_DATA(state) {
      getLeaseList({
        equipment: state.mobileSearchParams.equipment,
        isActivation: state.mobileSearchParams.isActivation,
        customer: state.mobileSearchParams.customer,
        isExpires: state.mobileSearchParams.isExpires,
        lt3Days: state.mobileSearchParams.lt3Days,
        pageNum: state.mobilePage.pageNum,
        lineNum: state.mobilePage.lineNum,
      }).then((res) => {
        state.mobileTableData.length = 0;
        if (res.code === 200 && res.message === '成功') {
          state.mobilePage.total = res.data.total;
          res.data.records.forEach((item) => {
            Object.keys(item).forEach((key) => {
              if (item[key] === null) {
                item[key] = "-";
              }
            });
            if (item.type === 3) {
              item.purchaseDays = "∞";
              item.purchaseNum = "∞";
              item.expiresDate = "∞";
            }
          });
          state.mobileTableData.push(...res.data.records);
        }
      });
    }
  },
  actions: {
  },
  getters: {
    // @ts-ignore
    user: (state) => state.user.user,
    // @ts-ignore
    menu: (state) => state.user.menu,
    // @ts-ignore
    visionShowType: (state) => state.user.visionShowType,
    // @ts-ignore
    pageInfo: (state) => state.pageInfo.userComponentsSize,
    // @ts-ignore
    monitorType: (state) => state.pageInfo.userMonitorType,
    // @ts-ignore
    cacheComponentsPath: (state) => state.pageInfo.cacheComponentsPath,
    // @ts-ignore
    screeningResultEdit: (state) => state.pageInfo.screeningResultEdit,
    // @ts-ignore
    updateSreeningList: (state) => state.pageInfo.updateSreeningList,
    // @ts-ignore
    step: (state) => state.pageInfo.step,
    // @ts-ignore
    load: (state) => state.pageInfo.loading,
    // @ts-ignore
    printList: (state) => state.pageInfo.printList,
  },
  modules: {
    user: moduleA,
    pageInfo: modulePage,
  },
});
/* eslint-disable */
